import { styled } from "@mui/material/styles";

export const TableContainer = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: auto;
`;
